import React, { useEffect } from "react";
import { analytics } from "../firebaseConfig";
import { logEvent } from "firebase/analytics";
const Success = () => {
  
  useEffect(()=>{
    logEvent(analytics, 'subscription_success_page');
    setTimeout(
      function() {
        window.location = window.location.origin + '/'
      }, 2000);
  
  },[])

  return(
  <div className="text-center p-10">
    <h2 className="text-2xl font-semibold text-green-600">Subscription Successful!</h2>
    <p className="mt-4">Thanks for subscribing. You now have full access.</p>
  </div>
)};

export default Success;
